module.exports = __webpack_public_path__ + "components/flag/static/square/bm-cbbb0a7ead5ca75e8f7f4fb67b87a8d5.svg";